<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>疗养预约系统</el-breadcrumb-item>
        <el-breadcrumb-item>疗养院管理</el-breadcrumb-item>
        <el-breadcrumb-item>新增疗养院</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form :model="listParams" v-loading="tableLoading" :rules="checklistParams">
        <el-form-item label="名称：">
          <el-input v-model="listParams.name" size="small" placeholder="输入名称" style="width: 200px"> </el-input>
        </el-form-item>

        <el-form-item label="地址：">
          <el-input v-model="listParams.detailAddress" size="small" placeholder="输入地址" style="width: 200px"> </el-input>
        </el-form-item>

        <el-form-item class="align-center mgt10" style="padding-bottom: 20px; margin-top: 20px">
          <el-button size="small" type="primary" @click="saveAdd()"> 保存 </el-button>
          <el-button size="small" class="mgl20" @click="backToList">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableLoading: false,
      listParams: {
        name: "",
        detailAddress: "",
      },
    };
  },
  mounted() {},
  methods: {
    backToList: function () {
      this.$router.push({
        name: "convalescenceManagement",
      });
    },
    saveAdd: function () {
      if (this.listParams.name.trim().length > 20) {
        this.$message({
          message: "名称不能超过20个字符",
          type: "error",
        });
        return;
      }
      if (this.listParams.detailAddress.trim().length > 100) {
        this.$message({
          message: "地址不能超过100个字符",
          type: "error",
        });
        return;
      }
      this.tableLoading = true;
      if (this.listParams.name.trim().length != 0 && this.listParams.detailAddress.trim().length != 0) {
        const bodyParams = Object.assign(
          {},
          {
            name: this.listParams.name,
            detailAddress: this.listParams.detailAddress,
          }
        );
        this.$http({
          url: global.apiUrl + "/recuperate/recuperateAddress",
          method: "POST",
          body: bodyParams,
          headers: { "Content-Type": "application/json" },
        })
          .then(res => {
            if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
              this.tableLoading = false;

              this.$message({
                message: res.body.info,
                type: "success",
              });
              this.$router.push({
                name: "convalescenceManagement",
              });
            } else {
              this.tableLoading = false;
              this.$message({
                message: res.body.info,
                type: "error",
              });
            }
          })
          .catch(err => {
            this.tableLoading = false;

            console.error(err);
          });
      } else {
        this.tableLoading = false;
        this.$message({
          message: "名称和地址不能为空",
          type: "error",
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.el-checkbox-group {
  width: 625px;
}
.el-checkbox:nth-child(5n + 1) {
  margin-left: 0;
}

.hx-form-container {
  .spec-unit-style {
    .el-form-item__content {
      margin-left: 10px !important;
    }
  }
  .wang-editor-style {
    height: 600px;
    width: 60vw;
    margin-top: 10px;
    float: left;
    .wang-editor-body {
      height: 540px;
    }
  }
  .upload-thumbnail-img,
  .thumbnail-img {
    width: 100px;
    height: 50px;
    border: 1px solid #ebeef5;
    position: relative;
    overflow: hidden;
    margin-left: 10px;
    .upload-icon {
      font-size: 20px;
      display: inline-block;
      margin-top: 15px;
      margin-left: 40px;
    }
    .hidden-upload {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      filter: alpha(opacity=0); //filter 过滤器   兼容IE678
      z-index: 2;
      cursor: pointer;
    }
    .thumbnail-img-wrapped {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }
    .combined-img {
      position: relative;
      width: 100px;
      height: 50px;
      .hover-img {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 999;
        opacity: 0;
        .close-btn {
          font-size: 22px;
          color: #fff;
          position: absolute;
          left: 50%;
          margin-left: -11px;
          top: 50%;
          margin-top: -11px;
        }
      }
      .hover-img:hover {
        opacity: 1;
        cursor: pointer;
        background-color: rgba(0, 0, 0, 0.5);
      }
    }
  }
  .wrap-thumbnail-img {
    width: 100%;
    height: 50px;
    margin-top: 10px;
    display: flex;
  }
}
.ql-video {
  display: none !important;
}
</style>
